// Reusable style definitions for MyMusic IA (single source of truth for the
// homepage cards fallback + Create page selector when the DB is not connected).
// Slugs are computed with the SAME algorithm as the backend so /create?style=<slug>
// preselection stays consistent whether data comes from the API or this fallback.

export function slugify(text) {
  return (text || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 50) || 'morceau';
}

const RAW = [
  ['Gospel', 'https://images.unsplash.com/photo-1720186576697-24c1496a07e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=600', 'Chant spirituel, chœurs puissants et âme.'],
  ['Musique urbaine', 'https://images.unsplash.com/photo-1601643157091-ce5c665179ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=600', 'Sonorités urbaines modernes et beats percutants.'],
  ['Musique personnalisée urbaine', 'https://images.unsplash.com/photo-1611063158871-7dd3ed4a2ac8?crop=entropy&cs=srgb&fm=jpg&q=85&w=600', 'Création urbaine sur-mesure selon ton thème.'],
  ['Love Music personnalisée', 'https://images.unsplash.com/photo-1542460533-50ac46fb13d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=600', 'Ballade romantique douce et personnalisée.'],
  ['Spot d’entreprise', 'https://images.pexels.com/photos/1181658/pexels-photo-1181658.jpeg?auto=compress&cs=tinysrgb&w=600', 'Jingle publicitaire pro pour ta marque.'],
  ['Meilleurs vœux personnalisés', 'https://images.pexels.com/photos/34598092/pexels-photo-34598092.jpeg?auto=compress&cs=tinysrgb&w=600', 'Chanson de vœux festive et chaleureuse.'],
  ['Rap Ivoire', 'https://images.unsplash.com/photo-1600962815726-457c46a12681?crop=entropy&cs=srgb&fm=jpg&q=85&w=600', 'Rap ivoirien percutant, punchlines et énergie.'],
  ['Zouk', 'https://images.pexels.com/photos/31968513/pexels-photo-31968513.jpeg?auto=compress&cs=tinysrgb&w=600', 'Zouk sensuel et chaloupé des Antilles.'],
  ['Zouglou', 'https://images.unsplash.com/photo-1515658323406-25d61c141a6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=600', 'Zouglou ivoirien festif et engagé.'],
  ['RnB', 'https://images.pexels.com/photos/8412290/pexels-photo-8412290.jpeg?auto=compress&cs=tinysrgb&w=600', 'RnB moderne, mélodies smooth et groove.'],
  ['Coupé-Décalé', 'https://images.unsplash.com/photo-1578736641330-3155e606cd40?crop=entropy&cs=srgb&fm=jpg&q=85&w=600', 'Coupé-décalé énergique, ambiance dancefloor.'],
  ['Naija Music', 'https://images.unsplash.com/photo-1523689119443-df96632084a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=600', 'Afrobeats nigérian, groove et vibes.'],
  ['Drill Music', 'https://images.unsplash.com/photo-1601042879364-f3947d3f9c16?crop=entropy&cs=srgb&fm=jpg&q=85&w=600', 'Drill sombre, 808 lourdes et hi-hats rapides.'],
];

export const STYLES = RAW.map(([name, cover_url, description], i) => ({
  id: `local-${slugify(name)}`,
  slug: slugify(name),
  name,
  cover_url,
  description,
  default_prompt: null,
  sort_order: i,
}));
